import { STEPS } from "../../data/content";
import { Reveal } from "../../lib/motion";

export const WhatToExpect = () => {
  return (
    <section className="py-24 lg:py-36 bg-cream-100 relative overflow-hidden" aria-labelledby="expect-heading">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-16 lg:mb-20">
          <Reveal><p className="overline text-sage-dark mb-5">What to expect</p></Reveal>
          <Reveal delay={0.05}>
            <h2 id="expect-heading" className="font-serif text-4xl sm:text-5xl lg:text-6xl text-ink leading-[1.05] tracking-tight">
              Taking the first step, gently.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-lg text-ink-soft leading-relaxed">
              Reaching out can feel daunting. Here's exactly what happens — so there are no surprises,
              only a calm, clear path from your very first message.
            </p>
          </Reveal>
        </div>

        <div className="relative grid md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-5">
          {/* connecting line on large screens */}
          <div className="hidden lg:block absolute top-10 left-0 right-0 h-px bg-sage/30" aria-hidden />
          {STEPS.map((step, i) => (
            <Reveal key={step.n} delay={i * 0.1}>
              <div className="relative" data-testid="expect-step">
                <div className="relative z-10 flex h-20 w-20 items-center justify-center rounded-full bg-white border border-sage-light shadow-soft">
                  <span className="font-serif text-3xl text-sage-dark">{step.n}</span>
                </div>
                <h3 className="mt-7 font-serif text-2xl text-ink">{step.title}</h3>
                <p className="mt-3 text-[0.95rem] text-ink-soft leading-relaxed pr-4">{step.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
